var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEndorse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.78125 14.0001L12.5929 16.8234L18.2279 11.1768",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5462 2.85805C13.3512 2.16971 14.6696 2.16971 15.4862 2.85805L17.3296 4.44471C17.6796 4.74805 18.3329 4.99305 18.7996 4.99305H20.7829C22.0196 4.99305 23.0346 6.00805 23.0346 7.24471V9.22805C23.0346 9.68305 23.2796 10.348 23.5829 10.698L25.1696 12.5414C25.8579 13.3464 25.8579 14.6647 25.1696 15.4814L23.5829 17.3247C23.2796 17.6747 23.0346 18.328 23.0346 18.7947V20.778C23.0346 22.0147 22.0196 23.0297 20.7829 23.0297H18.7996C18.3446 23.0297 17.6796 23.2747 17.3296 23.578L15.4862 25.1647C14.6812 25.853 13.3629 25.853 12.5462 25.1647L10.7029 23.578C10.3529 23.2747 9.69958 23.0297 9.23292 23.0297H7.21458C5.97792 23.0297 4.96292 22.0147 4.96292 20.778V18.783C4.96292 18.328 4.71792 17.6747 4.42625 17.3247L2.85125 15.4697C2.17458 14.6647 2.17458 13.358 2.85125 12.553L4.42625 10.698C4.71792 10.348 4.96292 9.69471 4.96292 9.23971V7.23305C4.96292 5.99638 5.97792 4.98138 7.21458 4.98138H9.23292C9.68792 4.98138 10.3529 4.73638 10.7029 4.43305L12.5462 2.85805Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndorse);
export default __webpack_public_path__ + "static/media/endorse.0512fecaec2aec7684a17170b4944b0b.svg";
export { ForwardRef as ReactComponent };